import barba from '@barba/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Carousel, LoadTransition } from './comp';
import { tt__init, ToggleMuteVideos } from './custom';

jQuery(function() {
    const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

    if (isMobile) {
        barba.destroy();
    }
});

gsap.registerPlugin(ScrollTrigger);

// Utility functions for Barba transitions
const loaders = {
    activate: () => gsap.fromTo(
        ".loader",
        { right: "100%", left: "0%", opacity: 0.7 },
        { duration: 0.7, right: 0, left: 0, opacity: 1, ease: "Power4.easeIn", transformOrigin: "left center" }
    ),
    kill: () => gsap.fromTo(
        ".loader",
        { right: "0", left: "0%", opacity: 1 },
        { duration: 0.5, left: "100%", right: 0, opacity: 0.7, ease: "Power4.easeIn", transformOrigin: "left center" }
    )
};


function startFs(data, done) {
    const media = data.trigger.querySelector('video') || data.trigger.querySelector('img');
    if (!media) {
        done();
        return;
    }
    media.classList.add('media--old');
    const mediaBounds = media.getBoundingClientRect();

    const tl = gsap.timeline({
        paused: true,
        onComplete: done
    });

    tl.set(media, {
        position: 'fixed',
        left: mediaBounds.left,
        top: mediaBounds.top,
        width: media.offsetWidth,
        height: media.offsetHeight,
        zIndex: 21,
        objectFit: 'cover'
    });

    tl.call(() => {
        document.body.appendChild(media);
    });

    tl.to(media, {
        width: '100%',
        height: '100%',
        force3D: true,
        top: 0,
        left: 0,
        duration: 1,
        ease: 'expo.inOut'
    });

    tl.play();
}

function finishFs(data, done) {
    const tl = gsap.timeline({
        paused: true,
        onComplete: done
    });

    tl.call(() => {
        const video = data.next.container.querySelector('#fullvideo');
        const headerImage = data.next.container.querySelector('.headerimage');

        // destroy new video
        if (video) {
            video.pause();
            video.removeAttribute('src');
            video.load();
            const parent = video.parentNode;
            parent.removeChild(video);
        }

        if (headerImage) {
            headerImage.style.backgroundImage = 'none';
        }

        // add old media from homepage
        const mediaOld = document.querySelector('.media--old');
        if (mediaOld) {
            let parent;
            if (video) {
                parent = video.parentNode;
            } else if (headerImage) {
                parent = headerImage;
            } else {
                parent = document.querySelector('.page-videocontent-wrap');
            }

            if (parent) {
                if (mediaOld.tagName.toLowerCase() === 'video') {
                    mediaOld.classList.add('fullscreen-bg__video');
                    mediaOld.id = 'fullvideo';
                } else {
                    mediaOld.classList.add('fullscreen-bg__image');
                    mediaOld.style.width = '100%';
                    mediaOld.style.height = '100%';
                    mediaOld.style.objectFit = 'cover';
                }
                
                mediaOld.classList.remove('media--old');
                parent.appendChild(mediaOld);
            }

            if (mediaOld.tagName.toLowerCase() === 'video' && !mediaOld.muted) {
                const muteIcon = document.querySelector('.muteicon');
                if (muteIcon) muteIcon.classList.remove('mute');
            }

            gsap.set(mediaOld, {
                clearProps: 'all'
            });
        }
    });

    tl.from('.page-videocontent-wrap', {
        autoAlpha: 0
    });

    tl.play();
}

barba.init({
    // debug: true,
    timeout: 10000,
    sync: true,
    preventRunning: true,
    prefetchIgnore: ['/cookies-policy/', '/politica-de-cookies/', '/cookie-richtlinie/', '/politique-de-cookies/'],
    prevent: ({ el, event }) => {
        if (event.type === 'click') {
            // Use closest() to easily check if the clicked element or any of its parents have these classes
            if (el.closest && el.closest('.ab-item, .prevent, .lang-item')) {
                return true;
            }
        }
    },
    transitions: [
        {
            name: "siderect-trans",
            async leave() {
                await loaders.activate();
            },
            async after() {
                await loaders.kill();
            },
        },
        {
            name: "fullscreen-video",
            leave(data) {
                return startFs(data, this.async());
            },
            after(data) {
                return finishFs(data, this.async());
            },
            from: {
                namespace: ['home', 'featurecollection'],
            },
            to: {
                namespace: ['collection'],
            }
        }
    ],
    views: [
        {
            namespace: 'home',
            afterLeave() {
                ScrollTrigger.getAll().forEach(st => st.kill());
            }
        }
    ]
});


// --- Barba Hooks ---

barba.hooks.enter(() => {
    window.scrollTo(0, 0);
});

barba.hooks.beforeEnter((data) => {
    ScrollTrigger.getAll().forEach(st => st.kill());

    const cf_selector = 'div.wpcf7 > form';
    const $cf_forms = jQuery(data.next.container).find(cf_selector);

    if ($cf_forms.length > 0) {
        $cf_forms.each(function() {
            wpcf7.init(this);
        });
    }
});

barba.hooks.after((data) => {
    const nextHtml = data.next.html;
    const response = nextHtml.replace(
        /(<\/?)body( .+?)?>/gi,
        "$1notbody$2>",
        nextHtml
    );

    if (jQuery('html').hasClass('fp-enabled')) {
        if (typeof window.fullpage_api !== 'undefined') {
            window.fullpage_api.destroy('all');
        }
    }

    const bodyClasses = jQuery(response).filter("notbody").attr("class");
    jQuery("body").attr("class", bodyClasses);

    tt__init();
    ToggleMuteVideos(data.next.container);
    
    ScrollTrigger.refresh();
});
